import React, {memo, useCallback} from 'react';
import {Popover, PopoverBody, PopoverHeader} from 'reactstrap';

const InformationHelper = memo(({name, text, title = 'Hint'}) => {
    const [helpOpen, setHelpOpen] = React.useState(false);

    const toggle = () => {
    };

    const show = useCallback(() => setHelpOpen(true));
    const hide = useCallback(() => setHelpOpen(false));

    const id = `help_${name}`;

    return (
        <>
            <i className='mdi mdi-information-outline font-15 ml-2 cursor-pointer'
               id={id} onMouseEnter={show} onMouseLeave={hide}/>
            <Popover placement="bottom" isOpen={helpOpen} target={id} toggle={toggle}>
                <PopoverHeader>{title}</PopoverHeader>
                <PopoverBody>{text}</PopoverBody>
            </Popover>
        </>
    );
});

export default InformationHelper;
